export default __webpack_public_path__ + "static/media/iab-active-customers.33e72ce4.svg";